import { Injectable } from '@angular/core';
import { appSettings, errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class LargewavetrendService extends BaseService {

  constructor( private _commonService: CommonService,
    private _widgetHelper: WidgethelperService) {    
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("BroadcastLargeWaveTrends").subscribe(
      (data: any) => {
        console.log("BroadcastLargeWaveTrends", data);
        let result: Array<any> = [];
        result = data;
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime && !widget.IfNoDataFound) {
          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;
          let lineData = [];
          let category = [];
          let hasData: boolean = false;

          for (let i = 0; i < result.length; i++) {
            if (!widget.IfNoDataFound) {
              hasData = true;
              category.push(result[i].WAVE_NBR);
              lineData.push(result[i].WAVE_TIME);
            }
          }

          if (!hasData) {
            widget.errorMessage = errorMessages.noWidgetData;
          }
          else {
            widget.errorMessage = null;
          }
          this.addDataSeries(widget.chartOptions, lineData, 'Wave Process Time', 'line')
          widget.chartOptions.xAxis.data = category;
          widget.chartOptions.grid.left = '6%';
          widget.chartOptions.grid.bottom = '6%';
          widget.chartOptions.xAxis.axisLabel.rotate = 45;
          if(widget.chartOptions.yAxis && widget.chartOptions.yAxis.length > 0){
            widget.chartOptions.yAxis[0].name = 'in Mins';
            widget.chartOptions.yAxis[0].nameLocation ='center';
            widget.chartOptions.yAxis[0].nameTextStyle = {padding: [0, 0, 10, 0] }           
          }
          
          this.addZoomBar(widget.chartOptions);
          this._commonService.lastUpdatedTime = lastUpdatedTime;
        }

        if (widget.IfNoDataFound) {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        widget.dataLoaded = true;
      },
      err => {
        console.log("listenFor BroadcastLargeWaveTrends error", err);
      }
    );

  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/largewavetrend.service.ts